import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

 transform(value: any): string {

    if (typeof value !== 'number') {
      value = Number(value);
    }

    if (isNaN(value)) {
      return '';
    }

    const isNegative = value < 0;
    const absValue = Math.abs(value);
    let formattedValue = NumberFormatterPipe.abbreviateCurrency(absValue);

    return isNegative ? `- ${formattedValue}` : formattedValue;

  }

  private formatWithCommas(value: number): string {
    if (isNaN(value)) {
      return '';
    }

    const [integer, decimal] = value.toFixed(2).split('.');

    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let formattedDecimal = decimal ? decimal.replace(/0+$/, '') : '';

    return formattedDecimal ? `${formattedInteger}.${formattedDecimal}` : formattedInteger;
  }

  static getIndianCurrencyFormat(amount: string, allowDecimal: boolean = false): string {
    let amountStr = amount;
    let decimalVal = "00";
    let decimalFound = amountStr.indexOf(".");
    let returnVal = "";

    if (decimalFound > -1) {
      decimalVal = amountStr.substring(decimalFound + 1);
      amountStr = amountStr.substring(0, decimalFound);
      decimalVal = decimalVal.substring(0, 2);
    }

    let stringBuilder: string[] = [];
    let amountArray = amountStr.split("");
    let a = 0, b = 0;

    for (let i = amountArray.length - 1; i >= 0; i--) {
      if (a < 3) {
        stringBuilder.push(amountArray[i]);
        a++;
      } else if (b < 2) {
        if (b === 0) {
          stringBuilder.push(",");
          stringBuilder.push(amountArray[i]);
          b++;
        } else {
          stringBuilder.push(amountArray[i]);
          b = 0;
        }
      }
    }

    returnVal = stringBuilder.reverse().join("");

    if (allowDecimal && decimalFound > -1) {
      returnVal = `${returnVal}.${decimalVal}`;
    }

    return returnVal;
  }


  static abbreviateCurrency(amount: number): string {
    if (amount > 99999) {
      let abbreviatedAmount: string;
      if (amount > 10000000) {
        abbreviatedAmount = this.getIndianCurrencyFormat((amount / 10000000).toString(), true) + " Crs";
      } else if (amount === 10000000) {
        abbreviatedAmount = this.getIndianCurrencyFormat((amount / 10000000).toString(), true) + " Cr";
      } else if (amount > 100000) {
        abbreviatedAmount = this.getIndianCurrencyFormat((amount / 100000).toString(), true) + " Lacs";
      } else if (amount === 100000) {
        abbreviatedAmount = this.getIndianCurrencyFormat((amount / 100000).toString(), true) + " Lac";
      } else {
        abbreviatedAmount = amount.toString();
      }

      return abbreviatedAmount;
    } else {
      return this.getIndianCurrencyFormat(amount.toString(), true);
    }
  }

}
